(() => {
  if (window.iaServicesReady) return;
  window.iaServicesReady = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let frame = false;
  const update = () => {
    frame = false;
    if (reduced.matches) return;
    document.querySelectorAll('[data-ia-sculpture], .ia-services-hero').forEach((element) => {
      const rect = element.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      const progress = Math.max(-1, Math.min(1, (window.innerHeight / 2 - rect.top - rect.height / 2) / window.innerHeight));
      element.style.setProperty('--ia-service-progress', progress.toFixed(3));
    });
  };
  const request = () => {
    if (!frame) { frame = true; window.requestAnimationFrame(update); }
  };
  window.addEventListener('scroll', request, {passive:true});
  window.addEventListener('resize', request, {passive:true});
  document.addEventListener('shopify:section:load', request);
  reduced.addEventListener('change', () => {
    document.querySelectorAll('[data-ia-sculpture], .ia-services-hero').forEach((element) => element.style.removeProperty('--ia-service-progress'));
    request();
  });
  request();
})();
